import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { faArrowUpRight } from '@fortawesome/pro-solid-svg-icons';
import theme from 'styles/themes/default';

import Block from 'components/atom/Block';
import Button from 'components/atom/Form/Button';
import Text from 'components/atom/Text/styles';
import AvatarInvitation from 'components/molecule/AvatarInvitational';
import ProfileInfo from 'components/organisms/ProfileInfo';

import { TypeInvitation } from '../../types';
import { Container, FooterCard, HeaderCard, InfoUser } from './styles';

interface ICardInvitationProps extends IMatchmakingInvitation {
  type: TypeInvitation;
  setInvitation: (type: TypeInvitation) => void;
}

const CardInvitation: React.FC<ICardInvitationProps> = ({
  professionalId,
  type,
  fullname,
  avatar,
  companyName,
  name,
  setInvitation,
}) => {
  const { t } = useTranslation();

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [prospectionId, setProspectionId] = useState<string | null>(null);

  return (
    <Block>
      <Container>
        <HeaderCard>
          <AvatarInvitation name={fullname} src={avatar} type={type} />

          <InfoUser>
            <Text weight="bold" size={16} lineHeight={19.2}>
              {type === 'received'
                ? t('meetings:list.receivedInvitation')
                : t('meetings:list.sentInvitation')}
              {fullname}
            </Text>

            {type === 'received' ? (
              <Text lineHeight={20} color={theme.colors.texts_light}>
                {companyName}
              </Text>
            ) : (
              <Text weight="bold" lineHeight={20} color={theme.colors.warning.color}>
                {name} {t('meetings:list.pendingInvitation')}.
              </Text>
            )}
          </InfoUser>
        </HeaderCard>

        <hr />

        <FooterCard>
          {type === 'received' && (
            <>
              <Button
                theme="purple"
                text={t('meetings:actions.reply')}
                disabledUppercase
                icon={faArrowUpRight}
                iconPosition="right"
                onClick={() => setInvitation(type)}
              />
            </>
          )}

          {type === 'sent' && (
            <>
              <Button
                theme="blue03-bordered"
                text={t('meetings:actions.details')}
                disabledUppercase
                iconPosition="right"
                onClick={() => setInvitation(type)}
              />
            </>
          )}

          <Button
            theme="light-bordered"
            icon={faUser}
            onClick={() => {
              setProspectionId(String(professionalId));
              setIsOpenModal(true);
            }}
          />
        </FooterCard>
      </Container>

      {isOpenModal && prospectionId && (
        <ProfileInfo
          isOpen={isOpenModal}
          onclose={() => {
            setIsOpenModal(false);
            setProspectionId(null);
          }}
          prospectionId={prospectionId}
        />
      )}
    </Block>
  );
};

export default CardInvitation;
